import React from 'react';

export const Play = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.21809 12.4853L8.21808 4.26719L18.9706 12.4853L8.21808 20.7034L8.21809 12.4853Z"
      fill="black"
    />
  </svg>
);
